(function () {
  function initTestimonial(section) {
    if (section.dataset.testimonialReady === 'true') return;

    const cards = Array.from(section.querySelectorAll('.testimonial-card'));
    const dots = Array.from(section.querySelectorAll('.testimonial-dot'));
    const slider = section.querySelector('.testimonial-slider');
    const total = cards.length;

    if (!total || !slider) return;
    section.dataset.testimonialReady = 'true';

    let current = 0;
    let timer;
    let touchStartX = 0;
    const delay = 4500;

    function render(index) {
      current = (index + total) % total;
      const previous = (current - 1 + total) % total;
      const next = (current + 1) % total;

      cards.forEach(function (card, cardIndex) {
        card.classList.remove('active', 'is-prev', 'is-next');
        card.setAttribute('aria-hidden', cardIndex === current ? 'false' : 'true');

        if (cardIndex === current) card.classList.add('active');
        if (total > 1 && cardIndex === previous) card.classList.add('is-prev');
        if (total > 2 && cardIndex === next) card.classList.add('is-next');
      });

      dots.forEach(function (dot, dotIndex) {
        const selected = dotIndex === current;
        dot.classList.toggle('active', selected);
        dot.setAttribute('aria-current', selected ? 'true' : 'false');
      });
    }

    function stopAuto() {
      window.clearInterval(timer);
    }

    function startAuto() {
      stopAuto();
      if (total > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(function () { render(current + 1); }, delay);
      }
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        if (index !== current) {
          render(index);
          startAuto();
        }
      });
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        render(index);
        startAuto();
      });
    });

    slider.addEventListener('mouseenter', stopAuto);
    slider.addEventListener('mouseleave', startAuto);
    slider.addEventListener('focusin', stopAuto);
    slider.addEventListener('focusout', startAuto);
    slider.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
      stopAuto();
    }, { passive: true });
    slider.addEventListener('touchend', function (event) {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) > 45) render(current + (distance < 0 ? 1 : -1));
      startAuto();
    }, { passive: true });

    render(0);
    startAuto();
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('.testimonial-section')) initTestimonial(scope);
    scope.querySelectorAll('.testimonial-section').forEach(initTestimonial);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
